module.exports = __webpack_public_path__ + "img/empreendimento-logo-27.9837bd37.png";